module.exports = __webpack_public_path__ + "static/media/m_w_55.6190160e.png";